$(document).ready(function () {

    $('.piq-magazine__text').slick({
        dots: false,
        arrows: false,
        infinite: true,
        accessibility: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
    $('#pause-rotation').click(function () {
        $('.piq-magazine__text').slick('slickPause');
    });
    $('#play-rotation').click(function () {
        $('.piq-magazine__text').slick('slickPlay');
    });
    $('.piq-magazine__text').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var i = nextSlide + 1;
        $('.piq-magazine__logo-item').removeClass('active');
        $('.piq-magazine__logo-item').attr('aria-current', 'false');
        $('.piq-magazine__logo-item[data-index=' + i + ']').addClass('active');
        $('.piq-magazine__logo-item[data-index=' + i + ']').attr('aria-current', 'true');
    });
    $('.piq-magazine__logo-item').hover(function () {
        $('.piq-magazine__logo-item').removeClass('active');
        $('.piq-magazine__logo-item').attr('aria-current', 'false');
        $(this).addClass('active');
        $(this).attr('aria-current', 'true');
        var i = parseInt($(this).data('index')) - 1;
        $('.piq-magazine__text').slick('slickGoTo', i);
    });
    $('.piq-magazine__logo-item').focus(function () {
        $('.piq-magazine__logo-item').removeClass('active');
        $('.piq-magazine__logo-item').attr('aria-current', 'false');
        $(this).addClass('active');
        $(this).attr('aria-current', 'true');
        var i = parseInt($(this).data('index')) - 1;
        $('.piq-magazine__text').slick('slickGoTo', i);
    });
    $('.piq-magazine__logo-item').click(function () {
        $('.piq-magazine__logo-item').removeClass('active');
        $('.piq-magazine__logo-item').attr('aria-current', 'false');
        $(this).addClass('active');
        $(this).attr('aria-current', 'true');
        var i = parseInt($(this).data('index')) - 1;
        $('.piq-magazine__text').slick('slickGoTo', i);
    });
})